import React from "react";
import PropTypes from "prop-types";

export function TaskAssigneeSelectorHeader({ name, children }) {
  return (
    <div>
      <div style={{ paddingBottom: "0.5em" }}>
        Reassign {name}&apos;s incomplete tasks to:
      </div>
      {children}
      <div style={{ color: "#B8B8B8", fontSize: "90%", paddingTop: "0.8em" }}>
        For compliance purposes, tasks previously completed by {name} will be
        left assigned.
      </div>
    </div>
  );
}

TaskAssigneeSelectorHeader.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
};

TaskAssigneeSelectorHeader.defaultProps = {
  children: null,
  name: "this user",
};

export default TaskAssigneeSelectorHeader;
